export default __webpack_public_path__ + "static/media/creator-iv-audio@3x.1d660fcf.png";